module.exports = __webpack_public_path__ + "img/platinumRiver.0bf80f2.jpg";